export enum QuotationStates {
  Ongoing = "Ongoing",
  Study = "Study",
  Converted = "Converted",
  Abandoned = "Abandoned",
  Expired = "Expired",
  ExpireSoon = "Arrive à Expiration",
  ToValidate = "ToValidate",
}
